import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUser, IUserIP } from "src/models/Maintenance/User.models";

interface UserState {
  users: IUser[];
  userToEdit: IUser | null;
  userIPs: IUserIP[];
  userIPToEdit: IUserIP | null;
}

const initialState: UserState = {
  users: [],
  userToEdit: null,
  userIPs: [],
  userIPToEdit: null
};

const userSlice = createSlice({
  name: "User",
  initialState,
  reducers: {
    setUserList: (state, action: PayloadAction<IUser[]>) => {
      state.users = action.payload;
    },
    setUserIPsList: (
      state: UserState,
      action: PayloadAction<IUserIP[]>
    ) => {
      state.userIPs = action.payload;
    },
    addUserIP: (state: UserState, action: PayloadAction<IUserIP>) => {
      state.userIPs.push(action.payload);
    },
    setUserIPToEdit:  (state: UserState, action: PayloadAction<IUserIP | null>) => {
      state.userIPToEdit = action.payload
    },
    updateUserIP: (
      state: UserState,
      action: PayloadAction<IUserIP>
    ) => {
      let itemIndex = state.userIPs.findIndex(
        item => item.userIpAddressId === action.payload.userIpAddressId
      );
      if (itemIndex !== -1) state.userIPs[itemIndex] = action.payload;
    },
    deleteUserIP: (
      state: UserState,
      action: PayloadAction<number>
    ) => {
      const newArray = state.userIPs.filter(
        item => item.userIpAddressId !== action.payload
      );
      state.userIPs = newArray;
    },
    concatListUser: (state: UserState, action: PayloadAction<IUser[]>) => {
      state.users = [...state.users.concat(action.payload)];
    },
    setUserToEdit: (state, action: PayloadAction<IUser | null>) => {
      state.userToEdit = action.payload;
    },
    addUser: (state, action: PayloadAction<IUser>) => {
      state.users.push(action.payload);
    },
    updateUser: (state, action: PayloadAction<IUser>) => {
      let itemIndex = state.users.findIndex(
        item => item.userId === action.payload.userId
      );
      if (itemIndex !== -1) state.users[itemIndex] = action.payload;
    },
    deleteUser: (state, action: PayloadAction<number>) => {
      const newArray = state.users.filter(
        item => item.userId !== action.payload
      );
      state.users = newArray;
    },
  },
});

export const {
  setUserList,
  concatListUser,
  setUserToEdit,
  addUser,
  updateUser,
  deleteUser,
  setUserIPsList,
  setUserIPToEdit,
  addUserIP,
  updateUserIP,
  deleteUserIP,
} = userSlice.actions;

export default userSlice.reducer;
